import React from "react";
import CustomSkeletonTable from "../../../../ui/CustomSkeletonTable/CustomSkeletonTable";
import RolesTableTanstack from "../../tables/RoleTableTanstack";
import RoleEmptyState from "./RoleEmptyState";

const RoleTableContent = ({
  loadingData,
  noRoles,
  noResults,
  filteredRoles,
  onEdit,
  onDelete,
}) => {
  if (loadingData) {
    return <CustomSkeletonTable columns={[1, 2, 3]} rowCount={10} />;
  }

  if (noRoles || noResults) {
    return <RoleEmptyState noRoles={noRoles} noResults={noResults} />;
  }

  return (
    <RolesTableTanstack
      data={filteredRoles}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  );
};

export default RoleTableContent;
